export default {
    dashboard: {
        totalWordsGenerated: 'Totalt antal genererade ord',
        wordsPerDay: 'Ord/dag',
        content: 'Innehåll',
        date: 'Datum',
        variationCount: 'Variationsantal',
        transactionId: 'Transaktions-ID',
        totalWordsCount: 'Totalt antal ord',
        action: 'Åtgärd',
        goTo: 'Gå till',
        viewMore: 'Visa mer',
        showLess: 'Visa mindre',
        tabImage: 'Bild',
        tabText: 'Text',
        dashboardSubtitle: 'Hantera ditt AI-genererade innehåll',
        type: 'Typ',
    },
};
